var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-page d-flex"},[_c('add-or-edit-training-module',{attrs:{"module":_vm.moduleToEdit,"title":_vm.$t('createFromTrainingModule'),"canEdit":_vm.canEdit},on:{"cancel":_vm.returnToView,"save":_vm.onSaveClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }